import React from 'react'
import { dayOfWeek, dayOfWeekShort } from '../util/helperfunctions'
import { Link } from 'react-router-dom'
import { format24h, format24hHour } from '../util/helperfunctions'

export default function CalendarItem({ calendarItemObj, setDeleteFunction }) {
  const handleDeleteClick = (id) => {
    setDeleteFunction(id)
  }

  return (
    <>
      <div className="card">
        <div className="card-header">

        </div>
        <div className="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <p>{dayOfWeek(calendarItemObj.date)}, {calendarItemObj.date} @ {format24h(calendarItemObj.time)}</p>
            <button type="button" class="btn btn-primary" onClick={() => handleDeleteClick(calendarItemObj.id)}>X</button>
          </div>

          <p>event: {calendarItemObj.event}</p>
          {(calendarItemObj.note) && (
            <p>note: {calendarItemObj.note}</p>
          )}
        </div>
        <div className="card-footer">

        </div>
      </div>
    </>
  )
}